<template>
  <div class="p-4">
    <nuxt-link
      :to="link"
      class="flex sm:block relative"
    >
      <div class="relative ml-3 sm:ml-0">
        <slider-list-product-image
          :files="props.files"
          :in-stock="inStock"
          :title="title"
        />

        <!--                      <div-->
        <!--                        class="absolute left-2 top-2 text-white rounded-full bg-white/30 text-xs px-2 py-1"-->
        <!--                        v-if="product.files.length > 1"-->
        <!--                      >-->
        <!--                        {{ product.files.length - 1 }}+-->
        <!--                      </div>-->

        <div class="absolute left-0 top-0 z-10">
          <div
            class="rounded-full bg-black/40 shadow-sm text-xs text-white px-2 py-1"
            v-if="!inStock"
          >
            ناموجود
          </div>
        </div>
      </div>

      <div>
        <div class="h-10">
          <h3 class="text-sm text-gray-800 line-clamp-2 mt-2">
            {{ title }}
          </h3>
        </div>

        <div class="h-4">
          <div
            class="inline-block rounded-full bg-black/40 shadow-sm text-xxs text-white px-2 py-px mt-2"
            v-if="quantityInPackage > 1"
          >
            پک
            {{ quantityInPackage }}
            تایی
          </div>
        </div>

        <!--        <div class="text-xs text-gray-500 line-clamp-1 mt-1">-->
        <!--          <base-icon-->
        <!--            name="location"-->
        <!--            class="text-xs"-->
        <!--          />-->
        <!--          از-->
        <!--          {{ cityTitle }}-->
        <!--        </div>-->

        <!--                    <div class="flex justify-end mt-4">-->
        <!--                      <div class="text-xs text-gray-400 whitespace-nowrap line-clamp-1">-->
        <!--                        {{ product.category?.title }}-->
        <!--                      </div>-->
        <!--                    </div>-->

        <div class="absolute sm:static left-0 bottom-0 text-left mt-4">
          <div class="text-sm font-bold text-gray-600">
            {{ calc_product_price(productVariations) }}
            <span class="text-xxs">{{ get_currency_suffix() }}</span>
          </div>
        </div>
      </div>
    </nuxt-link>
  </div>
</template>

<script setup>
import { format_currency } from '~/assets/js/functions/converts';
import SliderListProductImage from '~/components/sliders/SliderListProductImage.vue';
import get_currency_suffix from '../../assets/js/helpers/get_currency_suffix';

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  link: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  files: {
    type: Array,
    required: true,
  },
  productVariations: {
    type: Array,
    required: true,
  },
  quantityInPackage: {
    type: Number,
    required: true,
  },
  inStock: {
    type: Boolean,
    required: true,
  },
  cityTitle: {
    type: String,
    required: true,
  },
});

const calc_product_price = product_variations => {
  const prices = product_variations.map(pv => pv.$price);
  const min_price = Math.min(...prices);
  const max_price = Math.max(...prices);

  if (min_price === max_price) return format_currency(min_price);

  return [format_currency(min_price), format_currency(max_price)].join(' - ');
};
</script>

<style scoped></style>
